$(function () { $('[data-toggle="popover"]').popover() });
/*
$(function () { $('#collapse_airtransport').collapse('show')});
$(function () { $('#collapse_groundtransport').collapse('show')});
$(function () { $('#collapse_shippingguide').collapse('show')});
$(function () { $('#collapse_labeling').collapse('show')});
$(function () { $('#collapse_signal_word').collapse('show')});
$(function () { $('#collapse_hazard_statements').collapse('show')});
$(function () { $('#collapse_precautionary_statements').collapse('show')});
$(function () { $('#collapse_supplemental_hazard_statements').collapse('show')});
$(function () { $('#collapse_smiles_and_inchi').collapse('show')});
$(function () { $('#collapse_shipping_dropdown').collapse('show')}); 
*/

// toggle content on click
$('[data-toggle="collapse"]').click(function () {
    if ($(this).attr('data-start') == 'open') {
        $(this).html($(this).attr('data-close-text'));
    } else {
        $(this).html($(this).attr('data-open-text'));
    }
    $(this).attr('data-start', $(this).attr('data-start') == 'open' ? 'close' : 'open');
});

// set initial content
$(function () {
	$('[data-toggle="collapse"]').each( function () {
    	if ($(this).attr('data-start') == "open") {
    	    $(this).html($(this).attr('data-open-text'));
    	} else {
    	    $(this).html($(this).attr('data-close-text'));
    	}
	});
});


$('#addalltocart').click(function (){
	
  	//Get forms
  	var forms = document.getElementsByClassName("productforms");
	
   	//Define values to submit
   	var items=[];    
   	for(var i=0;i<forms.length;i++)
    {
      items.push({ id: forms[i].elements[1].value, quantity: forms[i].elements[0].value});
    }
    
     submitAll= function(items){
        if(items.length){
            var item=items.pop();
   			$.ajax({
 	  			url: "/cart/add",
   				type:'POST',
                data: item,
                success:function(){submitAll(items);},
                error:function(){submit(items);console.log('error here');}
            });
         }
        else{
        }
     return false;
     };
  	
    submitAll(items);
    
    Shopify.itemsToAdd = [];
  
    //document.location.href = '/cart';
    
  setTimeout(function(){
    		$('#addalltocart').blur();
  			$.getJSON('/cart.js', function(cart) {
        		if ('.badge' && $('.badge').size()) {
           			var value = $('.badge').html() || '0';
           			$('.badge').html(value.replace(/[0-9]+/,cart.item_count));
        		}
     		});
    		$('.quantity').each(function(){
                $(this).attr('value','0');
    		});    
             }, 500); 
     
    event.preventDefault();
});
  
// One button multiproduct submission with AJAX
// Adapted from https://gist.github.com/carolineschnapp/9122054
Shopify.itemsToAdd = [];

Shopify.addItemstoTheCart = function() {
  if (Shopify.itemsToAdd.length) {
    var item = Shopify.itemsToAdd.pop();
    $.ajax({
      url: '/cart/add',
      dataType: 'json',
      type: 'post',
      data: item,
      success: Shopify.addItemstoTheCart,
      error: Shopify.addItemstoTheCart
    });
  }
  else {
    //window.location.href = '/cart';
    			$.getJSON('/cart.js', function(cart) {
        		if ('.badge' && $('.badge').size()) {
           			var value = $('.badge').html() || '0';
           			$('.badge').html(value.replace(/[0-9]+/,cart.item_count));
        		}
     		});
    		$('.quantity').each(function(){
                $(this).attr('value','0');
    		});
   $('.add-to-cart-order-form').removeAttr('disabled').removeClass('disabled');
  }
};

jQuery(function($) {
  $('table .quantity:first').focus();
  $('[max]').change(function() {
    var max = parseInt($(this).attr('max'), 10);
    var value = parseInt($(this).val(), 10) || 0;
    if (value > max) { 
      alert('We only have ' + max + ' of this item in stock');
      $(this).val(max); 
    }    
  });
  $('.add-to-cart-order-form').click(function() {
    $('.add-to-cart-order-form').addClass('disabled').attr('disabled','disabled');
    // Resetting.
    Shopify.itemsToAdd = [];
    $('.quantity').each(function() {
      var quantity = parseInt($(this).val(), 10);
      if (quantity) {
        Shopify.itemsToAdd.push( { id: $(this).attr('data-id'), quantity: quantity } );
      }
    });     
    if (Shopify.itemsToAdd.length) {
      Shopify.addItemstoTheCart();
    }
    else {
      alert('All quantities are set to zero.');
      $('.add-to-cart-order-form').removeAttr('disabled').removeClass('disabled');
      event.preventDefault();

    }
  });
});


// Fix back-button stale cart-count
// from https://ecommerce.shopify.com/c/ecommerce-design/t/back-button-woes-35677
// jQuery.ajaxSetup({cache: false});
// https://ecommerce.shopify.com/c/ecommerce-design/t/error-with-design-of-simple-ecommerce-theme-and-shopping-cart-217958
$.getJSON('/cart.js', function(cart) {
        		if ('.badge' && $('.badge').size()) {
           			var value = $('.badge').html() || '0';
           			$('.badge').html(value.replace(/[0-9]+/,cart.item_count));
      			}
});


/* Shipping Tabs */

$('#myTab a').click(function (e) {
  e.preventDefault();
  $(this).tab('show');
})

/* Wufoo Form Submission without Redirect */
//$('#submitwf').click(function SubForm (){
            //$.ajax({
            //    url:'https://duquette.wufoo.com/forms/z1vzoo2g03ohlhn/#public',
            //    type:'post',
            //    data:$('#form1').serialize(),
            //    success:function(){
            //        alert("worked")'
           //    }
//            });
//})
        